<div class="main-dialog-container messanger-dialog default-popup">
        <div class="header header--bulk">
          <div class="close-btn" (click)="dialogRef.close(false)"></div>
        </div>
        
               <iframe width="100%" height="424px" allowtransparency="true" src="https://www.youtube.com/embed/hqVQQOFJ4kA?autoplay=1&mute=1&enablejsapi=1&cc_load_policy=1&vq=large" ></iframe>
               <!--<iframe width="100%" height="424px" allowtransparency="true" src="https://www.youtube.com/embed/hqVQQOFJ4kA?rel=0&amp;autoplay=1&cc_load_policy=1&vq=large&wmode=transparent" ></iframe>-->
        
</div>